import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getHodNavSections } from '../components/Sidebar/hodNavConfig';
import { buildDomainSections } from '../components/Sidebar/buildDomainSections';

/**
 * HodLayout — the read-only oversight shell for Head-of-Department users (UX-DR1, UX-DR2).
 * No operational create/edit/delete affordances are exposed here; security is enforced by
 * the backend (/api/hod/* GET-only, per-route VIEW_* grants), the UI merely hides mutations.
 */
const HodLayout = () => {
  const baseNavSections = useMemo(() => getHodNavSections(), []);
  const sections = useMemo(() => buildDomainSections(baseNavSections, 'hod'), [baseNavSections]);
  const shell = useMemo(
    () => ({
      homePath: '/hod/dashboard',
      profilePath: '/hod/profile',
    }),
    [],
  );

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath="/hod/dashboard" sections={sections} contentMaxWidth="lg">
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default HodLayout;
